export const BEFORE_ITEMS = [
  { key: 'silentInMeetings', emoji: '😐' },
  { key: 'strugglingToExpress', emoji: '😐' },
  { key: 'struggleToFindWords', emoji: '😐' },
  { key: 'fearSpeakingUp', emoji: '😐' },
] as const

export const AFTER_ITEMS = [
  { key: 'speakingWithConfidence', emoji: '😊' },
  { key: 'clearCompellingDelivery', emoji: '😊' },
  { key: 'speakWithEloquence', emoji: '😊' },
  { key: 'engageEffortlessly', emoji: '😊' },
] as const
